if ( document.querySelector(".team-slider")) {
    jQuery('.team-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        autoplay: false,
        rows: 0,
        infinite: true,
        swipeToSlide: true,
        prevArrow:'<svg class="slick-arrow slick-prev" xmlns="http://www.w3.org/2000/svg" width="24.571" height="36.413" viewBox="0 0 24.571 36.413"><path d="M21.388 33.231 6.363 18.206 21.388 3.181" fill="none" stroke="#e4034b" stroke-width="9"/></svg>',
        nextArrow:'<svg class="slick-arrow slick-next" xmlns="http://www.w3.org/2000/svg" width="24.571" height="36.413" viewBox="0 0 24.571 36.413"><path d="m3.182 3.182 15.025 15.025L3.182 33.232" fill="none" stroke="#e4034b" stroke-width="9"/></svg>',
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1150,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 639,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
    jQuery('.team-card').on('click', '.read-bio', function(e){
        e.target.closest('.team-card').classList.add('open');
    })
    jQuery('.team-card').on('click', '.close-bio', (e) => {
        e.target.closest('.team-card').classList.remove('open');
    })
    jQuery('.team-slider').on('click touch', '.slick-arrow', function(){
        jQuery('.team-slider .team-card').removeClass('open');
    });

    jQuery('.team-slider .read-bio').on('focus', (e) => {
        requestAnimationFrame(()=> {
            e.currentTarget.parentElement.parentElement.parentElement.scrollTop = 0
        });
    });
}
